import styled from "styled-components";
import { PrimaryButton, PrimaryButtonProps } from "components/shared/buttons";
import { ModalActionButtonStyles } from "./ModalActionButtonStyles";

export const ModalPrimaryActionButton = styled(PrimaryButton)<PrimaryButtonProps>`
  ${ModalActionButtonStyles};
`;
